import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface SkeletonLoaderProps {
  rows?: number
  columns?: number
  showHeader?: boolean
  className?: string
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  rows = 5,
  columns = 6,
  showHeader = true,
  className,
}) => {
  return (
    <div
      className={
        className
          ? `${css(styles.container)} ${className}`
          : css(styles.container)
      }
    >
      {showHeader && (
        <div className={css(styles.header)}>
          {Array.from({ length: columns }).map((_, index) => (
            <div
              key={`header-${index}-${Math.random()}`}
              className={css(styles.headerCell)}
            />
          ))}
        </div>
      )}
      <div className={css(styles.body)}>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            key={`row-${rowIndex}-${Math.random()}`}
            className={css(styles.row)}
          >
            {Array.from({ length: columns }).map((_, colIndex) => (
              <div
                key={`cell-${rowIndex}-${colIndex}-${Math.random()}`}
                className={css(styles.cell)}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid #e5e7eb',
  },
  header: {
    display: 'flex',
    backgroundColor: '#f9fafb',
    borderBottom: '1px solid #e5e7eb',
    padding: '12px 16px',
  },
  headerCell: {
    flex: 1,
    height: '20px',
    backgroundColor: '#e5e7eb',
    borderRadius: '4px',
    margin: '0 4px',
    animation: 'pulse 1.5s ease-in-out infinite',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    padding: '16px',
    borderBottom: '1px solid #f3f4f6',
    ':last-child': {
      borderBottom: 'none',
    },
  },
  cell: {
    flex: 1,
    height: '16px',
    backgroundColor: '#f3f4f6',
    borderRadius: '4px',
    margin: '0 4px',
    animation: 'pulse 1.5s ease-in-out infinite',
  },
})

export default SkeletonLoader
